/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { $el, bind, getStrTypeAttr, removeAttrs, setCss, setHtml } from '../../dom-utils';
import { warn } from '../../mixins';
import { type, validComps } from '../../utils';
import PREFIX from '../prefix';
var Avatar = /** @class */ (function () {
    function Avatar() {
        this.VERSION = 'v1.0';
        this.COMPONENTS = $el('r-avatar', { all: true });
        this._create(this.COMPONENTS);
    }
    Avatar.prototype.config = function (el) {
        var target = $el(el);
        validComps(target, 'avatar');
        var AvatarImage = target.querySelector('img');
        return {
            events: function (_a) {
                var onError = _a.onError;
                if (!AvatarImage) {
                    warn("Unable to add an event where the image failed to load for the current avatar --> \"" + el + "\"");
                    return;
                }
                bind(AvatarImage, 'error', function (event) { return onError && type.isFn(onError, event); });
            }
        };
    };
    Avatar.prototype._create = function (COMPONENTS) {
        var _this = this;
        COMPONENTS.forEach(function (node) {
            var _a = _this._attrs(node), icon = _a.icon, src = _a.src, alt = _a.alt, size = _a.size;
            _this._setSize(node, size);
            _this._setIcon(node, icon);
            _this._setImage(node, src, alt);
            _this._setText(node, icon, src);
            removeAttrs(node, ['icon', 'src', 'alt']);
        });
    };
    Avatar.prototype._setSize = function (node, size) {
        if (!size)
            return;
        var _size = Number(size);
        if (!_size)
            return;
        setCss(node, 'width', _size + "px");
        setCss(node, 'height', _size + "px");
        setCss(node, 'fontSize', _size / 2 + "px");
        node.removeAttribute('size');
    };
    Avatar.prototype._setIcon = function (node, icon) {
        if (!icon)
            return;
        node.classList.add(PREFIX.avatar + "-icon");
        var AvatarIcon = "<i class=\"" + PREFIX.icon + " " + PREFIX.icon + "-" + icon + "\"></i>";
        setHtml(node, AvatarIcon);
    };
    Avatar.prototype._setImage = function (node, src, alt) {
        if (!src)
            return;
        node.classList.add(PREFIX.avatar + "-image");
        var AvatarImage = "<img src=\"" + src + "\" alt=\"" + alt + "\" />";
        setHtml(node, AvatarImage);
    };
    Avatar.prototype._setText = function (node, icon, src) {
        if (icon || src)
            return;
        if (!setHtml(node))
            return;
        var text = setHtml(node);
        var AvatarText = "<span class=\"" + PREFIX.avatar + "-string\">" + text + "</span>";
        setHtml(node, AvatarText);
        this._setScale(node);
    };
    // 防止字符型头像的字体溢出边界
    Avatar.prototype._setScale = function (node) {
        var children = node.querySelector("." + PREFIX.avatar + "-string");
        if (!children)
            return;
        var avatarWidth = node.getBoundingClientRect().width;
        var childrenWidth = children.offsetWidth;
        if (avatarWidth - 8 < childrenWidth) {
            var newScale = "scale(" + (avatarWidth - 8) / childrenWidth + ") translateX(-50%)";
            setCss(children, 'transform', "" + newScale);
        }
        else {
            setCss(children, 'transform', 'scale(1) translateX(-50%)');
        }
    };
    Avatar.prototype._attrs = function (node) {
        return {
            icon: getStrTypeAttr(node, 'icon', ''),
            src: getStrTypeAttr(node, 'src', ''),
            alt: getStrTypeAttr(node, 'alt', ''),
            size: getStrTypeAttr(node, 'size', '')
        };
    };
    return Avatar;
}());
export default Avatar;
